<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_vii">CONTENTS</a></p><a id="page_vii">
</a><p class="toca"><a id="page_vii"></a><a href="#/xhtml/07_Acknowledgement"><i>Acknowledgments</i></a></p>
<p class="tocb"><a href="#/xhtml/09_Introduction">Introduction</a></p>
<p class="toc"><a href="#/xhtml/10_Chapter01">1.  Unconventional Maestro</a></p>
<p class="toc"><span href="#/xhtml/11_Chapter02" title="Link target outside of Sample">2.  Janus-Faced Modernism</span></p>
<p class="toc"><span href="#/xhtml/12_Chapter03" title="Link target outside of Sample">3.  New Instruments, New Sounds, and New Musical Law</span></p>
<p class="toc"><span href="#/xhtml/13_Chapter04" title="Link target outside of Sample">4.  From Opera to Films</span></p>
<p class="toc"><span href="#/xhtml/14_Chapter05" title="Link target outside of Sample">5.  New Sonic Landscapes</span></p>
<p class="toc"><span href="#/xhtml/15_Chapter06" title="Link target outside of Sample">6.  New Music of the Weimar Republic</span></p>
<p class="toc1"><span href="#/xhtml/16_Chapter07" title="Link target outside of Sample">7.  Conclusions: “Passing the Torch”</span></p>
<p class="tocb"><span href="#/xhtml/17_Bibliography" title="Link target outside of Sample"><i>Selected Bibliography</i></span></p>
<p class="tocb"><span href="#/xhtml/18_Index01" title="Link target outside of Sample"><i>Index</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Contents.vue?16e580c7